import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  .job-icon {
    font-size: 1rem;
    margin-right: 1rem;
    display: flex;
    align-items: center;
    svg {
      color: var(--text-secondary-color);
    }
  }
  .job-text {
    text-transform: capitalize;
    margin-right: 1rem;
    letter-spacing: var(--letter-spacing);
  }
`;
export default Wrapper;


